import { Box, Skeleton } from "@mui/material"
import type { FC } from "react"

export const PurchaseCostsSkeleton: FC = () => (
  <Box className='flex flex-col gap-y-4' data-testid='product.purchase-costs.skeleton'>
    {[0, 1].map((index) => (
      <Box key={index} className='flex flex-col border border-gray-400'>
        <Skeleton variant='rectangular' height={40} className='bg-primary-100' />
        <Box className='flex gap-x-4 p-4'>
          <Skeleton variant='rectangular' width={420} height={200} />
          <Skeleton variant='rectangular' width={420} height={200} />
        </Box>
      </Box>
    ))}
  </Box>
)
